import { zeroUUID } from '@sbt-web/optimizely-sdk';
import { getSSROptimizelyClient } from '@/tools/optimizely/ssrClient';

const HOUSTON_ID = 'subito-product-marketing.listing.filter-badge-new';

const isNonEmptyObject = (obj: unknown) =>
  !!obj && typeof obj === 'object' && Object.keys(obj).length > 0;

const getFiltersWithNewBadge = async (): Promise<string[]> => {
  const ssrOptimizely = await getSSROptimizelyClient();

  if (!ssrOptimizely) {
    return [];
  }

  const isEnabled = ssrOptimizely.isFeatureEnabled(HOUSTON_ID, zeroUUID);

  if (!isEnabled) {
    return [];
  }

  const response = ssrOptimizely.getAllFeatureVariables(
    HOUSTON_ID,
    zeroUUID
  ) as Record<string, boolean>;

  if (!isNonEmptyObject(response)) {
    return [];
  }

  const enabledFilters = Object.entries(response)
    .filter(([, isEnabled]) => isEnabled)
    .map(([filterURI]) => filterURI);

  return enabledFilters;
};

export { getFiltersWithNewBadge };
